import {} from '@busybusy/webapp-react-ui';
import { EquipmentInspectionType } from '__generated__/graphql';
import classNames from 'classnames';
import BasicPicker from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IEquipmentInspectionTypePickerProps {
  className?: ClassName;
  value: string | null;
  onSelect: (value: string | null) => void;
}

const EquipmentInspectionTypePicker = (props: IEquipmentInspectionTypePickerProps) => {
  const { className, value, onSelect } = props;

  const data: { id: string; name: string }[] = [
    { id: EquipmentInspectionType.Manual, name: t('Manual') },
    { id: EquipmentInspectionType.PostOperation, name: t('Post Operation') },
    { id: EquipmentInspectionType.PreOperation, name: t('Pre Operation') },
    { id: EquipmentInspectionType.Routine, name: t('Routine') },
  ];

  const classes = classNames('equipment-inspection-type-picker', className);

  return (
    <BasicPicker className={classes} value={value} onSelect={onSelect} placeholder={t('Inspection Type')} data={data} />
  );
};

export default EquipmentInspectionTypePicker;
